import React from 'react';

import { FilterSelect } from '@/components/shared/FilterSelect/FilterSelect';
import { ContentStatus } from '@addmile/backend-client';

import { CONTENT_STATUS, SUPPORTED_LANGUAGES } from '../../const';

export type GetCollectionParams = {
  cursor?: number;
  title?: string;
  language?: string;
  status?: ContentStatus[];
  pageSize?: number;
};

interface CollectionFiltersProps {
  filters: GetCollectionParams;
  onFilterChange: (
    key: keyof GetCollectionParams,
    value: GetCollectionParams[keyof GetCollectionParams],
  ) => void;
}

export const CollectionFilters: React.FC<CollectionFiltersProps> = ({
  filters,
  onFilterChange,
}) => {
  return (
    <div className="gap-4 bg-gray-50 rounded-lg mb-4">
      <input
        className="px-3 py-3 border border-neutral-20 rounded-lg text-sm w-full max-w-[551px]"
        type="text"
        value={filters.title || ''}
        onChange={(e) => onFilterChange('title', e.target.value || undefined)}
        placeholder="Search by title..."
      />

      <div className="flex gap-4 mt-3">
        <FilterSelect
          label="Status"
          value={filters.status && filters.status.length > 0 ? filters.status[0] : ''}
          onChange={(value) => {
            onFilterChange('status', value ? ([value] as ContentStatus[]) : undefined);
          }}
          options={[
            { value: '', label: 'All Statuses' },
            ...CONTENT_STATUS.map(({ value, label, icon, color }) => ({
              value,
              label,
              icon,
              color,
            })),
          ]}
        />

        <FilterSelect
          label="Language"
          value={filters.language || ''}
          onChange={(value) => onFilterChange('language', value || undefined)}
          options={[
            { value: '', label: 'All Languages' },
            ...SUPPORTED_LANGUAGES.map(({ value, label, icon }) => ({
              value,
              label,
              icon,
            })),
          ]}
        />
      </div>
    </div>
  );
};

export default CollectionFilters;
